module.exports = __webpack_public_path__ + "media/logos/new-york-times-logo-black-ca9d0f42.png";